/**
 * 模組頁面代碼 : 1320-UI-04
 * 頁面說明 : 職位管理列表畫面
 * @module web/modules/role-permission/components/PositionListModal
 */

// ----- import from npm modules ----
import React, {useEffect} from 'react';

// ----- import from local modules -----
import {BaseComponent} from '../../../components/BaseComponent';
import enumList from 'web/utils/enumList';
import {usePositionListModal} from '../hooks/usePositionListModal';

const PositionListModal = React.forwardRef((props, ref) => {
  const {
    onPosition,
    positionList,
    onEditPositionStatus,
    needPositionListLoad,
    setNeedPositionListLoad,
  } = props;
  const baseComponent = new BaseComponent(props);
  const {preparePositionListTable} = usePositionListModal(
    baseComponent,
    positionList,
  );

  // // 當表格的容器可見後，調整列寬
  const adjustTableWhenVisible = () => {
    const tableContainer = document.querySelector('#datatable__positionList'); // 假設這是表格的容器

    if (tableContainer && tableContainer.offsetParent !== null) {
      const t = preparePositionListTable();
      t.columns.adjust().draw();
    } else {
      setTimeout(adjustTableWhenVisible, 100); // 容器不可見，稍後再嘗試
    }
  };

  useEffect(() => {
    if (needPositionListLoad) {
      setNeedPositionListLoad(false);

      const maskElement = document.querySelector('#modal-mask-position');
      // 顯示遮罩
      maskElement.style.opacity = '0.5';

      //   // 隱藏遮罩
      maskElement.style.opacity = '0';
      setTimeout(() => {
        maskElement.style.display = 'none';
      }, 200);

      // 重新繪製表格
      adjustTableWhenVisible();
    }
  }, [needPositionListLoad]);

  useEffect(() => {
    const handleChange = (event) => {
      const checkbox = event.target.closest('input[type="checkbox"]');
      if (checkbox && checkbox.id.startsWith('eab-position-')) {
        const index = parseInt(checkbox.id.split('-')[2]);
        const mode = checkbox.checked
          ? enumList.alertModalModeEnums.enable
          : enumList.alertModalModeEnums.disable;
        const updatePosition = positionList[index];
        if (updatePosition) {
          let message = '';
          if (mode === enumList.alertModalModeEnums.enable) {
            message = `啟用 [ ${updatePosition.positionName} ]`;
          } else {
            message = `停用 [ ${updatePosition.positionName} ]`;
          }
          onEditPositionStatus(mode, message, updatePosition.positionCode);
        } else {
          console.log('No role found at index:', index);
        }
      }
    };
    const handleEditClick = (e) => {
      const button = e.target.closest('.btn');
      if (button && button.id.startsWith('edit-position-')) {
        const positionId = parseInt(button.id.split('-')[2]);
        if (positionId) {
          onPosition(enumList.modalMode.edit, positionId);
        }
      }
    };

    if (ref.current?._dialog) {
      ref.current?._dialog.addEventListener('change', handleChange);
      ref.current?._dialog.addEventListener('click', handleEditClick);
    }
    return () => {
      if (ref.current?._dialog) {
        ref.current?._dialog.removeEventListener('change', handleChange);
        ref.current?._dialog.removeEventListener('click', handleEditClick);
      }
    };
  }, [positionList]);

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalPositionList"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalPositionListLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalRoleListForm"
          noValidate
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalPositionListLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href="#ico-users-edit"></use>
                </svg>
              </div>
              <div className="modal__title__text">職位管理</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div id="modal-mask-position" className="modal-mask"></div>
            <div className="datatable__tool mb-2">
              <div className="d-flex align-items-center gap-2 ms-auto">
                {baseComponent.checkPermission(
                  enumList.moduleEnums.position,
                  enumList.accessModeEnums.create,
                ) && (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    id="modalRoleBtnNew"
                    onClick={() => onPosition()}
                  >
                    <svg className="btn__icon me-2" aria-hidden="true">
                      <use href="#ico-plus"></use>
                    </svg>
                    新增
                  </button>
                )}
              </div>
            </div>
            <div className="datatable__data">
              <table
                id="datatable__positionList"
                className="display table table-hover align-middle nowrap"
                style={{width: '100%'}}
              ></table>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
});

export default PositionListModal;
